import hybridProducts from './hybridProducts';

export default hybridProducts;
